import { useEffect, useState } from "react";
import { StorageContextProvider } from "context/storageContext";
import WithContextProvider from "components/WithContextProvider";
import Header from "components/Header";
import Map from "components/Map";
import { MapContextProvider } from "context/mapContext";
import ToolBar from "./components/ToolBar";
import MapSelectors from "./components/MapSelectors";
import PolesSelection from "./components/PolesSelection";
import PaletteTracking from "./components/PaletteTracking";
import UnitsReport from "./components/UnitsReport";
import UnitsHistoryReport from "./components/UnitsHistoryReport";
import PolesReport from "./components/PolesReport";
import RemovedUnitsReport from "./components/RemovedUnitsReport";
import InstallationReport from "./components/InstallationReport";
import HandoverReports from "./components/HandoverReports";
// import InstallationReport from "./components/InstallationReport";
// import StatusReport from "./components/StatusReport";

function Home() {
  const [selectedTool, setSelectedTool] = useState();
  useEffect(() => {
    setSelectedTool("polesSelection");
  }, []);

  const handleChangeSelectedTool = (event) => {
    setSelectedTool(event.target.dataset.tool);
  };
  return (
    <MapContextProvider>
      <div className="flex_container">
        <Header />
        <main style={{ flex: "1 1 0" }} className="tool_main">
          <div
            className={`tool ${
              selectedTool === "unitsReport" ||
              selectedTool === "unitsHistoryReport" ||
              selectedTool === "polesReport" ||
              selectedTool === "removedUnitsReport"
                ? "hide-map"
                : ""
            }`}
          >
            <ToolBar
              selectedTool={selectedTool}
              handleChangeSelectedTool={handleChangeSelectedTool}
            />
            {selectedTool === "polesSelection" && <PolesSelection />}
            {selectedTool === "paletteTracking" && <PaletteTracking />}
            {selectedTool === "unitsReport" && <UnitsReport />}
            {selectedTool === "unitsHistoryReport" && <UnitsHistoryReport />}
            {selectedTool === "polesReport" && <PolesReport />}
            {selectedTool === "removedUnitsReport" && <RemovedUnitsReport />}
            {selectedTool === "installationReport" && <InstallationReport />}
            {selectedTool === "handoverReports" && <HandoverReports />}
            <div className="tool__map">
              {selectedTool === "polesSelection" && <MapSelectors />}
              <Map selectedTool={selectedTool} />
            </div>
          </div>
        </main>
      </div>
    </MapContextProvider>
  );
}

export default WithContextProvider(Home, StorageContextProvider);
